import React from 'react';
import './AccountDetails.scss';

/**
 * Renders the account details section
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const AccountDetails = ({ customer, activeSection }) => {
  const DETAILS_SECTION = 'My Account';

  /**
   * Render the addresses
   * @param addresses
   * @returns {*}
   */
  const renderAddresses = (addresses) => {
    if (addresses.length !== 0) {
      return addresses.map((address, i) => {
        if (address.address !== customer.defaultAddress) {
          return (
            <div
              key={`address-${i}`}
              className="c-account-details__address"
              dangerouslySetInnerHTML={{ __html: address.address }}
            ></div>
          );
        }
      });
    }
  };

  return (
    <div className={`c-account-details ${activeSection === DETAILS_SECTION ? 'is-active' : ''}`}>
      <div className="c-account-details__section">
        <h4 className="c-account-details__heading h3-roobert">Personal Information</h4>
        <div className="c-account-details__content body-2">
          {customer.firstName} {customer.lastName}
          <br />
          {customer.email}
          <br />
          {customer.phone}
        </div>
      </div>
      <div className="c-account-details__section">
        <h4 className="c-account-details__heading h4-roobert">My Addresses</h4>
        <div className="c-account-details__content c-account-details__addresses-container body-2">
          <div className="c-account-details__address default-address">
            <h4 className="c-account-details__address-heading eyebrow-2">DEFAULT</h4>
            <div dangerouslySetInnerHTML={{ __html: customer.defaultAddress }}></div>
          </div>
          {renderAddresses(customer.addresses)}
        </div>
      </div>
    </div>
  );
};

export default AccountDetails;
